import React from 'react';

import {ChatType} from 'graphql-client/__generated/graphqlGlobalTypes';
import DataCaptureAssistantChat from 'llm/data-capture/DataCaptureAssistantChat';
import {DeepResearchChat} from 'llm/deep-research/DeepResearchChat';
import {assertNever} from 'util/Types';

/**
 * Delegates rendering to the appropriate chat component based on the chat type.
 *
 * This is logically a part of ChatRouter, but moving it into its own file makes it easier to mock;
 * it also allows new chat type developers from having to grok the ChatRouter internals.
 */
export default function ChatRouterChat({
  chatId,
  chatType,
  onCreateChat,
  onRequestNewChat,
}: {
  chatId: string | null;
  chatType: ChatType;
  onCreateChat: (chatId: string) => void;
  onRequestNewChat: () => void;
}): JSX.Element {
  switch (chatType) {
    case ChatType.DEEP_RESEARCH:
      return (
        <DeepResearchChat chatId={chatId} onCreateChat={onCreateChat} onRequestNewChat={onRequestNewChat} />
      );
    case ChatType.DATA_CAPTURE:
      return <DataCaptureAssistantChat />;
    default:
      throw new Error(`Unexpected chat type: ${assertNever(chatType)}`);
  }
}
